var _style, _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAyudaventas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 95.4 105.9",
    style: {
      enableBackground: "new 0 0 95.4 105.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000096769048257451011670000014058559591025477784_);}\n\t.st1{fill:#00632E;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 95.4,
    height: 105.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094604160847892600290000002751611164770137487_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ayudaventas",
    style: {
      clipPath: "url(#SVGID_00000094604160847892600290000002751611164770137487_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    className: "st1",
    d: "M83.7,105.9c-1.7,0-3.4-0.3-4.9-1.1c-1.4-0.7-2.6-1.6-3.5-2.8c-1.1-1.5-2-3.1-2.7-4.9 c-0.9-2-1.6-3.8-2.3-5.3l0,0L66,80.7H28.7L24.5,92c-1.9,5.2-3.6,8.6-5,10.5c-1.7,2.2-4.4,3.4-8,3.4c-3,0-5.9-1.2-8-3.3 c-2.2-2-3.5-4.7-3.5-7.7c0-1.6,0.3-3.2,0.8-4.8C1.2,88.7,2,86.6,3,84l5.2-13.3c0.4-1,1.6-1.5,2.6-1.1c1,0.4,1.5,1.6,1.1,2.6 L6.7,85.5c-1,2.5-1.7,4.5-2.2,5.8C4.2,92.5,4,93.7,4,94.9c0,1.9,0.9,3.6,2.3,4.8c1.4,1.4,3.3,2.2,5.3,2.2c2.3,0,3.9-0.6,4.8-1.8 c0.8-1.1,2.2-3.6,4.4-9.5L26,76.7h42.8l5.2,13.6c0.6,1.5,1.4,3.2,2.2,5.2c0.6,1.4,1.3,2.8,2.2,4c0.6,0.7,1.3,1.3,2.2,1.7 c1,0.5,2.1,0.7,3.1,0.6c2.1,0,4.1-0.8,5.5-2.3c1.4-1.2,2.2-3,2.3-4.9c0-1.3-0.5-4.1-2.9-9.8l0,0L62.8,21.3l0,0 c-1.2-3.1-2.2-5.7-3-7.6c-0.7-1.7-1.6-3.4-2.7-5c-1-1.4-2.3-2.6-3.8-3.5c-1.8-0.9-3.9-1.4-6-1.3c-2.1-0.1-4.1,0.4-5.9,1.3 c-1.5,0.9-2.9,2.1-3.8,3.5c-1.2,1.9-2.2,3.9-3,6l0,0.1c-1,2.5-1.8,4.7-2.5,6.5L18.2,57.8c-0.4,1-1.6,1.5-2.6,1.1 c-1-0.4-1.5-1.5-1.1-2.5L28.2,20c0.7-1.8,1.6-4,2.5-6.5l0-0.1c0.9-2.4,2-4.7,3.4-6.8c1.3-2,3.1-3.6,5.2-4.8 c2.4-1.3,5.1-1.9,7.9-1.8c2.8-0.1,5.5,0.5,7.9,1.8c2.1,1.1,3.8,2.7,5.2,4.7c1.2,1.8,2.3,3.7,3.1,5.7c0.8,1.9,1.8,4.5,3,7.7 l25.7,63.6c2.1,5.1,3.2,8.8,3.2,11.3c0,2.9-1.3,5.7-3.4,7.7C89.8,104.7,86.8,105.9,83.7,105.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    className: "st1",
    d: "M60.9,65.7H33.7c-1.5,0-2.8-1.2-2.8-2.8c0-0.3,0.1-0.6,0.2-0.9l13.5-37.6 c0.4-1.1,1.4-1.8,2.6-1.8h0c1.2,0,2.2,0.7,2.6,1.8L63.5,62c0.5,1.4-0.2,3-1.6,3.5C61.6,65.6,61.2,65.7,60.9,65.7 M35.4,61.7h23.8 l-12-32.9L35.4,61.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    className: "st1",
    d: "M13.2,66.6c-1.1,0-2-0.9-2-2c0-0.2,0-0.4,0.1-0.6l0.3-1c0.3-1,1.4-1.6,2.5-1.3 c1,0.3,1.6,1.4,1.3,2.5c0,0,0,0.1,0,0.1l-0.3,1C14.8,66.1,14.1,66.6,13.2,66.6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAyudaventas);
export default __webpack_public_path__ + "static/media/Ayudaventas.d073b7b017d0de26fd7cd8a93eda3956.svg";
export { ForwardRef as ReactComponent };